import actions from './actions';
import {
  removeCartItem,
  removeCartItemGroup,
  updateLineItemQuantity,
} from '../../apis/vistacartApi';
import { cartSelectors } from '../cart';
import {
  trackItemsRemoved,
  prefetchItemsRemovedTrackingData,
} from '../../apis/trackingApi';
import {
  trackCartItemRemoveError,
  trackCartItemQuantityUpdateError,
  trackCartItemGroupRemoveError,
  noticeError,
} from '../../apis/newRelicTracking';

const remove = itemId => async (dispatch, getState) => {
  dispatch(actions.CARTITEMS_REMOVE_START(itemId));
  const tenant = cartSelectors.selectTenant(getState().cart);
  const shopperId = cartSelectors.selectShopperId(getState().cart);
  try {
    const itemTrackingData = prefetchItemsRemovedTrackingData(
      [itemId],
      null,
      getState().cart,
      getState().cartItems,
      getState().pricing
    );
    await removeCartItem(tenant, shopperId, itemId);
    dispatch(actions.CARTITEMS_REMOVE_SUCCESS(itemId));
    trackItemsRemoved(itemTrackingData);
  } catch (error) {
    if (!error.nrReporterSource) {
      noticeError(error);
    }
    trackCartItemRemoveError(error);
    dispatch(actions.CARTITEMS_REMOVE_FAIL(itemId, error));
  }
};

const removeItemGroup =
  (cartItemIds, groupId) => async (dispatch, getState) => {
    dispatch(actions.CARTITEMGROUP_REMOVE_START(cartItemIds));
    const tenant = cartSelectors.selectTenant(getState().cart);
    const shopperId = cartSelectors.selectShopperId(getState().cart);
    try {
      const itemTrackingData = prefetchItemsRemovedTrackingData(
        cartItemIds,
        groupId,
        getState().cart,
        getState().cartItems,
        getState().pricing
      );
      await removeCartItemGroup(tenant, shopperId, groupId);
      dispatch(actions.CARTITEMGROUP_REMOVE_SUCCESS(cartItemIds, groupId));
      trackItemsRemoved(itemTrackingData);
    } catch (error) {
      if (!error.nrReporterSource) {
        noticeError(error);
      }
      trackCartItemGroupRemoveError(error);
      dispatch(actions.CARTITEMGROUP_REMOVE_FAIL(cartItemIds, error));
    }
  };

const updateQuantity =
  ({ itemId, quantityToUpdateTo, originalQuantity }) =>
  async (dispatch, getState) => {
    dispatch(
      actions.CARTITEMS_QUANTITY_UPDATE_START(
        itemId,
        Number(quantityToUpdateTo)
      )
    );
    const tenant = cartSelectors.selectTenant(getState().cart);
    const shopperId = cartSelectors.selectShopperId(getState().cart);
    try {
      await updateLineItemQuantity(
        tenant,
        shopperId,
        itemId,
        quantityToUpdateTo
      );
      dispatch(actions.CARTITEMS_QUANTITY_UPDATE_SUCCESS(itemId));
    } catch (error) {
      if (!error.nrReporterSource) {
        noticeError(error);
      }
      trackCartItemQuantityUpdateError(error);

      dispatch(
        actions.CARTITEMS_QUANTITY_UPDATE_FAIL(itemId, originalQuantity, error)
      );
    }
  };

export default {
  remove,
  removeItemGroup,
  updateQuantity,
};
